import { render, staticRenderFns } from "./PaymentQuota.vue?vue&type=template&id=14d21601&"
import script from "./PaymentQuota.vue?vue&type=script&lang=js&"
export * from "./PaymentQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports